import {
  Flex,
  HeaderIcon,
  IconClose,
  IconCouponSignUp,
  IconLogoApple,
  IconLogoKakao,
  IconSigninEmail,
  IconSigninFacebook,
  IconSigninNaver,
  StackScreen,
  Typography,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { AnalyticsScreen } from 'shared/src/context';
import { useHandleBackPressed } from 'shared/src/hooks';
import { useRedirectIfLoggedIn } from '../../useRedirectIfLoggedIn';
import { useConsumePendingSocialAuth } from './hooks/useConsumePendingSocialAuth';
import { useLogClickSignInByEmail } from './hooks/useLogClickSignInByEmail';
import { useLogClickSocialAccount } from './hooks/useLogClickSocialAccount';
import { useLogViewIntroSignUp } from './hooks/useLogViewIntroSignUp';
import { useLoginPress } from './hooks/useLoginPress';
import type { SocialLoginType } from './types';

const LoginContent = () => {
  const { width } = useScreenSize();
  const { bottom: safeAreaBottom } = useSafeArea();
  const { onPressBack } = useHandleBackPressed();
  const handlePress = useLoginPress();
  const logClickSocialAccount = useLogClickSocialAccount();
  const logClickSignInByEmail = useLogClickSignInByEmail();

  // 이미 로그인된 사용자는 로그인 화면에서 되돌려보낸다.
  useRedirectIfLoggedIn();

  useLogViewIntroSignUp();

  // 소셜 콜백(/auth/:provider)에서 넘어온 provider 토큰으로 JWT 발급 (2단계)
  useConsumePendingSocialAuth();

  const handleSocialPress = (type: SocialLoginType) => {
    logClickSocialAccount(type);
    handlePress(type);
  };

  const handleEmailPress = () => {
    logClickSignInByEmail();
    handlePress('email');
  };

  return (
    <StackScreen
      hideBackButton
      rightIcons={[
        <HeaderIcon key={'close'} onPress={onPressBack}>
          <IconClose />
        </HeaderIcon>,
      ]}
    >
      <Flex flex={1} width={width} alignSelf={'center'}>
        <Flex
          flex={1}
          alignItems={'center'}
          justifyContent={'center'}
          padding={{ top: 44 }}
        >
          <Typography
            type={'h2'}
            color={'content_primary'}
            textAlign={'center'}
          >
            {'첫 구매라면 누구나\n'}
            <Typography type={'h2'} color={'content_pink_primary'}>
              {'30% 쿠폰팩'}
            </Typography>
            {' 즉시 지급!'}
          </Typography>
          <Flex margin={{ top: 30 }}>
            <IconCouponSignUp />
          </Flex>
        </Flex>

        <Flex padding={{ horizontal: 40, bottom: safeAreaBottom + 24 }}>
          <Flex
            horizontal
            alignItems={'center'}
            justifyContent={'center'}
            gap={12}
            height={48}
            borderRadius={8}
            backgroundColorValue={'#FEE500'} // 카카오 브랜드 컬러 
            margin={{ bottom: 8 }}
            onPress={() => handleSocialPress('kakao')}
          >
            <IconLogoKakao />
            <Typography type={'subtitle2'} color={'content_primary'}>
              {'카카오로 3초 만에 시작하기'}
            </Typography>
          </Flex>

          <Flex
            horizontal
            alignItems={'center'}
            justifyContent={'center'}
            gap={12}
            height={48}
            borderRadius={8}
            backgroundColor={'bg_black_button'}
            margin={{ bottom: 20 }}
            onPress={() => handleSocialPress('apple')}
          >
            <IconLogoApple />
            <Typography type={'subtitle2'} color={'content_always_white'}>
              {'Apple로 계속하기'}
            </Typography>
          </Flex>

          <Flex horizontal justifyContent={'center'} gap={16}>
            <Flex onPress={() => handleSocialPress('naver')}>
              <IconSigninNaver />
            </Flex>
            <Flex onPress={() => handleSocialPress('facebook')}>
              <IconSigninFacebook />
            </Flex>
            <Flex onPress={handleEmailPress}>
              <IconSigninEmail />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </StackScreen>
  );
};

export const LoginScreen = () => (
  <AnalyticsScreen screen={'INTRO_SIGN_UP'} hostsModals={false}>
    <LoginContent />
  </AnalyticsScreen>
);
